<template>
  <div class="icon" :style="style">
    <svg width="80" height="80" viewBox="0 0 85 85">
      <circle cx="42" cy="42" r="38" :stroke="color" stroke-width="3" fill="white" />


      <!-- Home ikona -->
      <g transform="translate(16, 14) scale(0.05)">
        <path d="M833.978 454.112l-290.09-273.974c-8.661-6.554-17.41-16.71-28.469-16.71h-4.632c-11.059 0-19.809 12.789-28.468 19.354l-292.86 271.456c-33.394 27.386-34.138 47.195-21.003 63.104 6.631 8.048 8.254 12.328 36.048 12.328l52.702-0.015v262.598c0 47.124 23.567 68.318 61.058 68.318h62.362l36.827-0.22V628.388c0-25.641 14.648-33.342 33.157-33.342h126.934c16.501 0 30.908 6.953 30.908 34.653v230.353l27.737 0.52h71.517c39.481 0 61.062-23.769 61.062-64.441V529.543l51.165-0.009c25.901 0 26.504 0.724 35.048-8.164 17.405-18.112 6.923-48.735-21.003-67.258z" fill="green" />
      </g>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  x: Number,
  y: Number,
  label: String,
  color: {
    type: String,
    default: '#000'
  }
})

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 30}px`,
  top: `${props.y - 30}px`,
  zIndex: 10
}))
</script>

<style scoped>
.icon {
  pointer-events: none;
}
</style>
